'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

var _styleHelpers = require('../../../styles/styleHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = (0, _extends3.default)({
  width: '100%',
  minHeight: '100px',
  '& .card': {
    border: 'none'
  },
  '& .fa-chevron-up, & .fa-chevron-down': {
    float: 'right',
    cursor: 'pointer'
  }
}, (0, _styleHelpers.makeAnimation)({
  name: 'vertical-grow',
  from: { transform: 'rotateX(90deg)' },
  to: { transform: 'rotateX(0deg)' },
  on: 'transform',
  duration: '200'
}));

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref, theme) {
  var onClick = _ref.onClick;
  return (0, _extends3.default)({
    '& .fa-chevron-up, & .fa-chevron-down': {
      color: theme.colors.primaryLight
    },
    backgroundColor: theme.colors.secondary,
    cursor: onClick ? 'pointer' : 'default',
    border: 'solid ' + theme.borderBase + 'px ' + theme.colors.primaryVeryLight,
    paddingTop: theme.paddingBase * 20 + 'px',
    paddingBottom: theme.paddingBase * 20 + 'px',
    paddingLeft: theme.paddingBase * 20 + 'px',
    paddingRight: theme.paddingBase * 20 + 'px',
    marginBottom: theme.marginBase * 40 + 'px'
  }, (0, _objectResolvePath2.default)(theme, 'ExpandableCard.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/cards/ExpandableCard/ExpandableCard.style.js
// module id = 458
// module chunks = 0